// src/components/PageLoader.jsx
import React, { useEffect, useState } from "react";
import Pages from "./pages";

const API = (process.env.REACT_APP_API_BASE_URL || "http://localhost:7000").replace(/\/$/, "");
const WEBSITE_ID = process.env.REACT_APP_WEBSITE_ID;

export default function PageLoader({ sectionSlug, itemSlug, fallbackTitle }) {
  const [item, setItem] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(
          `${API}/api/public/content-items/resolve-by-slug/${WEBSITE_ID}/${sectionSlug}/${itemSlug}`
        );
        if (!r.ok) throw new Error("Kunde inte hämta sidans innehåll");
        const { item } = await r.json();
        setItem(item);
      } catch (e) {
        setErr(e.message);
      }
    })();
  }, [sectionSlug, itemSlug]);

  if (err) return <div className="p-8 text-red-600">{err}</div>;
  if (!item) return <div className="p-8">Laddar in…</div>;

  return (
    <Pages
      title={item.name || fallbackTitle}
      content={item.content || ""}
      sectionSlug={sectionSlug}
      updatedAt={item.updatedAt}
      createdAt={item.createdAt}
    />
  );
}
